import { Route, Routes } from "react-router-dom";

import "./App.scss";

import RouteAuth from "./components/RouteAuth";

import Login from "./screens/Login";
import Dashboard from "./screens/Dashboard";
import DashboardGrupo from "./screens/DashboardGrupo";
import Usuarios from "./screens/Usuarios";
import UsuarioFormulario from "./screens/UsuarioFormulario";
import Alertas from "./screens/Alertas";
import AlertaFormulario from "./screens/AlertaFormulario";
import Empresas from "./screens/Empresas";
import EmpresaFormulario from "./screens/EmpresaFormulario";
import Grupos from "./screens/Grupos";
import GrupoFormulario from "./screens/GrupoFormulario";
import Monitores from "./screens/Monitores";
import MonitorFormulario from "./screens/MonitorFormulario";
import Variaveis from "./screens/Variaveis";
import VariavelFormulario from "./screens/VariavelFormulario";
import Status from "./screens/Status";
import StatusEmbed from "./screens/StatusEmbed";
import StatusGrupo from "./screens/StatusGrupo";
import Page404 from "./screens/Page404";

function App() {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route
				path="/dashboard"
				element={
					<RouteAuth>
						<Dashboard />
					</RouteAuth>
				}
			/>
			<Route
				path="/dashboardGrupo/:id"
				element={
					<RouteAuth>
						<DashboardGrupo />
					</RouteAuth>
				}
			/>

			<Route
				path="/usuarios"
				element={
					<RouteAuth>
						<Usuarios />
					</RouteAuth>
				}
			/>
			<Route
				path="/usuarioFormulario"
				element={
					<RouteAuth>
						<UsuarioFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth>
							<UsuarioFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth>
							<UsuarioFormulario />
						</RouteAuth>
					}
				/>
			</Route>
			<Route
				path="/alertas"
				element={
					<RouteAuth>
						<Alertas />
					</RouteAuth>
				}
			/>
			<Route
				path="/alertaFormulario"
				element={
					<RouteAuth>
						<AlertaFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth>
							<AlertaFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth>
							<AlertaFormulario />
						</RouteAuth>
					}
				/>
			</Route>
			<Route
				path="/empresas"
				element={
					<RouteAuth superUser={true}>
						<Empresas />
					</RouteAuth>
				}
			/>
			<Route
				path="/empresaFormulario"
				element={
					<RouteAuth superUser={true}>
						<EmpresaFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth superUser={true}>
							<EmpresaFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth superUser={true}>
							<EmpresaFormulario />
						</RouteAuth>
					}
				/>
			</Route>
			<Route
				path="/grupos"
				element={
					<RouteAuth>
						<Grupos />
					</RouteAuth>
				}
			/>
			<Route
				path="/grupoFormulario"
				element={
					<RouteAuth>
						<GrupoFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth>
							<GrupoFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth>
							<GrupoFormulario />
						</RouteAuth>
					}
				/>
			</Route>
			<Route
				path="/monitores"
				element={
					<RouteAuth>
						<Monitores />
					</RouteAuth>
				}
			/>
			<Route
				path="/monitorFormulario"
				element={
					<RouteAuth>
						<MonitorFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth>
							<MonitorFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth>
							<MonitorFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id/:task"
					element={
						<RouteAuth>
							<MonitorFormulario />
						</RouteAuth>
					}
				/>
			</Route>
			<Route
				path="/variaveis"
				element={
					<RouteAuth>
						<Variaveis />
					</RouteAuth>
				}
			/>
			<Route
				path="/variavelFormulario"
				element={
					<RouteAuth>
						<VariavelFormulario />
					</RouteAuth>
				}
			>
				<Route
					index
					element={
						<RouteAuth>
							<VariavelFormulario />
						</RouteAuth>
					}
				/>
				<Route
					path=":id"
					element={
						<RouteAuth>
							<VariavelFormulario />
						</RouteAuth>
					}
				/>
			</Route>

			<Route path="/status" element={<Status />} />
			<Route path="/statusEmbed" element={<StatusEmbed />} />
			<Route path="/statusGrupo/:id" element={<StatusGrupo />} />

			<Route path="*" element={<Page404 />} />
		</Routes>
	);
}

export default App;
